<script>
import axios from '@/utils/axios';
import { countries, states, pincodeWiseAddress } from '@/utils/admin';
import { useCurrenciesStore } from '@/stores/currenciesStore';

export default {
inject: ['setLoading'],
 data() {
  return { 
   ids: [], 
   errors: {}, 
   id: 0,
   user: '',
   source: '',
   name: '',
   email: '',
   mobile: '',
   gst_no: '',
   salutation: 'Mr.',
   designation: '',
   company_name: '',
   currency: '',
   website: '',
   address: '',
   city: '',
   state: null,
   country: null,
   pincode: '',
   shipping_address: '',
   shipping_city: '',
   shipping_state: null,
   shipping_country: null,
   shipping_pincode: '',
   sources: [],
   countries: [],
   states: [],
   shipping_states: [],
   users: [],
   currencies: [],
   remark: '',
   pincodeTimeout: null
  };
 },

 computed: {
  website_column(){
   return this.id ? 'col-md-7' : 'col-md-4'; 
  }
 },

 mounted() {
  
 },

 methods: {
  add(){
   this.resetForm();
   this.getSources();
   this.getCountries();
   this.getCurrencies();
  },

  async edit(id){
   this.resetForm(); 
   await this.getCountries();
   await this.getCurrencies();
   await this.customer(id);
  },

  async getAllUsers(){
   try{
    const response = await axios.get('/users/all-users');
    this.users = response.data.data; 
   }catch(error){
    console.log(error.message);
   } 
  },

  async customer(id){
   this.setLoading(true);
   try{
    const response = await axios.get(`/customers/${id}`);
    const data = response.data.data;
    this.id = data.id;
    this.company_name = data.company_name;
    this.name = data.name;
    this.email = data.email;
    this.mobile = data.mobile;
    this.gst_no = data.gst_no;
    this.salutation = data.salutation;
    this.designation = data.designation;
    this.website = data.website;
    this.address = data.address;
    this.pincode = data.pincode;
    this.city = data.city;

    this.shipping_address = data.shipping_address;
    this.shipping_pincode = data.shipping_pincode;
    this.shipping_city = data.shipping_city;
    
    this.country = this.countries.find(country => country.name === data.country);
    //LOAD BILLING STATES
    await this.getStates(this.country?.id);
    this.state = this.states.find(state => state.name === data.state);

    this.shipping_country = this.countries.find(country => country.name === data.shipping_country);
    //LOAD SHIPPING STATES
    await this.getShippingStates(this.shipping_country?.id);
    this.shipping_state = this.shipping_states.find(state => state.name === data.shipping_state);

   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async getCountries(){
   this.setLoading(true);
   try{
    const response = await countries();
    this.countries = response.data.data;
    if(!this.id){
     //if creating new customer, then set default country 
     this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
    }
    this.getStates(this.country?.id);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  onCountrySelect(country){
   this.getStates(country?.id);
  },

  async getStates(country_id){
   this.state = null;
   this.states = [];
    if(country_id){
    try{ 
     const response = await states(country_id);
     this.states = response.data.data;
     //if creating new customer, then set default country 
     this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state);
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   }  
  },

  onShippingCountrySelect(country) {
   this.getShippingStates(country?.id);
  },

  async getShippingStates(country_id){
   this.shipping_state = null;
   this.shipping_states = [];
   if(country_id){
    try{
     const response = await axios.get(`/states/${country_id}`);
     this.shipping_states = response.data.data;
     //if creating new customer, then set default country
     this.shipping_state = this.shipping_states.find(s => s.name === this.clientAdmin?.company?.state);
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   }
  },

  // async getCurrencies(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('currencies');
  //   this.currencies = response.data.data;
  //   this.currency = this.currencies.find(c => c.id === this.clientSetting?.currency_id);
  //  }catch(error){
  //   console.log(error.message);
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

  async getCurrencies(){
  try{
    const currenciesStore = useCurrenciesStore();
    this.currencies = await currenciesStore.loadCurrencies();
    this.currency = this.currencies.find(
      c => c.id === this.clientSetting?.currency_id
    );
  }catch(error){
    console.log(error.message);
  }
},

  async getSources(){
   this.setLoading(true);
   try{
    const response = await axios.get('/lead-sources');
    this.sources = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  },

  async saveCustomer(){
   this.errors = {};
   this.setLoading(true);
   try{
    const payload = {
     currency_id: this.currency?.id,
     lead_source_id: this.source?.id,
     name: this.name,
     email: this.email,
     mobile: this.mobile,
     gst_no: this.gst_no,
     salutation: this.salutation,
     designation: this.designation,
     company_name: this.company_name,
     address: this.address,
     city: this.city,
     state: this.state?.name,
     country: this.country?.name,
     pincode: this.pincode,
     shipping_address: this.shipping_address,
     shipping_city: this.shipping_city,
     shipping_state: this.shipping_state?.name,
     shipping_country: this.shipping_country?.name,
     shipping_pincode: this.shipping_pincode,
     website: this.website
    };
 
    let response = [];
    if(this.id){
     response = await axios.put(`/customers/${this.id}/update`, payload);
    }else{
     response = await axios.post(`/customers/create`, payload); 
    }
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('customer_modal');
    this.resetForm();
   }catch(error){
    if(error.type === 'validation'){
     this.errors = error.errors; 
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   } 
  },

  async deleteCustomer(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.delete(`/customers/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
   }catch(error){
    this.$swalToast(error.message, 'error'); 
   }finally{
    this.setLoading(false);
    this.$closeModal('customer_delete_modal');
   }
  },

  async assignForm(id){
   this.id = id; 
   await this.getAllUsers();
  },

  async assignCustomer(){
   this.errors = {}; 
   this.setLoading(true);
   try{
    const response = await axios.patch(`/customers/${this.id}/assign`, {
     user_id: this.user_id,
     remark: this.remark
    });
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('customer_assign_modal');
   }catch(error){
    if(error.type === 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error');
    }
   }finally{
    this.setLoading(false);
   } 
  },

  checkPincode(){
   if(this.pincode.length < 6){
    this.errors.pincode = ["The pincode field must be 6 digits."];
   }else{
    delete this.errors.pincode;
    clearTimeout(this.pincodeTimeout);
    this.pincodeTimeout = setTimeout(() => {
     this.addressByPincode();
    }, 500);   
   }
  },

  async addressByPincode(){
   this.setLoading(true);
   try{
    const response = await pincodeWiseAddress(this.pincode);
    const data = response.data.data;
    const new_country = data?.country ? this.countries.find(c => c.name === data.country) : this.country;
    this.city = data?.city || this.city;
    if(new_country && new_country?.id !== this.country?.id){
     this.country = new_country;
     await this.getStates(new_country.id);
     this.state = data?.state ? this.states.find(s => s.name === data.state) : this.state;
    }else if(data?.state){
     this.state = this.states.find(s => s.name === data.state);
    }
   }catch(error){
    console.log('Pincode lookup failed:', error.message);
   }finally{
    this.setLoading(false);
   }
  },

  resetForm() {
   this.id = null;
   this.source = '';
   this.name = '';
   this.email = '';
   this.mobile = '';
   this.gst_no = '';
   this.designation = '';
   this.company_name = '';
   this.address = '';
   this.city = '';
   this.state = '';
   this.country = '';
   this.pincode = '';
   this.shipping_address = '';
   this.shipping_city = '';
   this.shipping_state = '';
   this.shipping_country = '';
   this.shipping_pincode = '';
   this.errors = {};
  },

 },
};
</script>

<template>
<!-- Add Customer Modal -->
<div class="modal fade" id="customer_modal" tabindex="-1" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-lg">
<div class="modal-content shadow-lg rounded-0">
<!-- Header -->
<div class="modal-header py-3 rounded-0">
<h5 class="modal-title mb-0 fw-bold d-flex align-items-center">
 <i class="ti ti-user-plus me-2"></i> {{ id ? 'Edit' : 'Add' }} Customer
</h5>
 <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
</div>

<form @submit.prevent="saveCustomer">
  <!-- Tabs -->
  <div class="px-4 pt-3 pb-2 mb-1">
   <ul class="nav nav-tabs nav-tabs-compact border-0" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active px-3 py-2" id="info-tab" data-bs-toggle="tab" data-bs-target="#basic-info">
        <i class="ti ti-user-circle me-1"></i>Basic
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link px-3 py-2" id="address-tab" data-bs-toggle="tab" data-bs-target="#address">
        <i class="ti ti-map-pin me-1"></i>Shipping
      </button>
    </li>
   </ul>
  </div>

  <!-- Basic Info Tab -->
  <div class="tab-content px-4 pb-4" id="myTabContent">
    <div class="tab-pane fade show active" id="basic-info" role="tabpanel">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label fw-semibold small mb-2">Company Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="company_name" />
          <small class="text-danger" v-if="errors.company_name">{{ errors.company_name[0] }}</small>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-semibold small mb-2">Customer Name <span class="text-danger">*</span></label>
          <div class="input-group input-group-sm">
            <select class="form-select" style="max-width: 90px;" v-model="salutation">
              <option value="Mr.">Mr.</option>
              <option value="Ms.">Ms.</option>
              <option value="Mrs.">Mrs.</option>
            </select>
            <input type="text" class="form-control" v-model="name" />
          </div>
          <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">Email <span class="text-danger">*</span></label>
          <input type="email" class="form-control" v-model="email" />
          <small class="text-danger" v-if="errors.email">{{ errors.email[0] }}</small>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold small mb-2">Phone <span class="text-danger">*</span></label>
          <input type="tel" class="form-control" v-model="mobile" />
          <small class="text-danger" v-if="errors.mobile">{{ errors.mobile[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">Designation</label>
          <input type="text" class="form-control" v-model="designation" />
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">GST No</label>
          <input type="text" class="form-control" v-model="gst_no" />
          <small class="text-danger" v-if="errors.gst_no">{{ errors.gst_no[0] }}</small>
        </div>
        <div class="col-md-3" v-if="!id">
          <label class="form-label fw-semibold small mb-2">Source <span class="text-danger">*</span></label>
          <vue-select :options="sources" label="name" v-model="source" placeholder="Select" />
          <small class="text-danger" v-if="errors.lead_source_id">{{ errors.lead_source_id[0] }}</small>
        </div>
        <div :class="website_column">
          <label class="form-label fw-semibold small mb-2">Website</label>
          <input type="url" class="form-control" v-model="website" />
          <small class="text-danger" v-if="errors.website">{{ errors.website[0] }}</small>
        </div>
        <div class="col-md-5">
          <label class="form-label fw-semibold small mb-2">Street</label>
          <input type="text" class="form-control" v-model="address" />
          <small class="text-danger" v-if="errors.address">{{ errors.address[0] }}</small>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold small mb-2">Pincode <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="pincode" maxlength="6" @keyup="checkPincode" />
          <small class="text-danger" v-if="errors.pincode">{{ errors.pincode[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">City <span class="text-danger">*</span></label>
          <input type="text" class="form-control" v-model="city" />
          <small class="text-danger" v-if="errors.city">{{ errors.city[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">Country <span class="text-danger">*</span></label>
          <vue-select :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" />
          <small class="text-danger" v-if="errors.country">{{ errors.country[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">State <span class="text-danger">*</span></label>
          <vue-select :options="states" label="name" v-model="state" />
          <small class="text-danger" v-if="errors.state">{{ errors.state[0] }}</small>
        </div>
      </div>
    </div>

    <!-- Shipping Tab -->
    <div class="tab-pane fade px-4 pb-4" id="address" role="tabpanel">
      <div class="row g-3">
        <div class="col-md-9">
          <label class="form-label fw-semibold small mb-2">Street Address</label>
          <input type="text" class="form-control" v-model="shipping_address" />
          <small class="text-danger" v-if="errors.shipping_address">{{ errors.shipping_address[0] }}</small>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold small mb-2">Pincode</label>
          <input type="text" class="form-control" v-model="shipping_pincode" />
          <small class="text-danger" v-if="errors.shipping_pincode">{{ errors.shipping_pincode[0] }}</small>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">City</label>
          <input type="text" class="form-control" v-model="shipping_city" />
          <small class="text-danger" v-if="errors.shipping_city">{{ errors.shipping_city[0] }}</small>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">Country</label>
          <vue-select :options="countries" label="name" v-model="shipping_country" @update:modelValue="onShippingCountrySelect" />
          <small class="text-danger" v-if="errors.shipping_country">{{ errors.shipping_country[0] }}</small>
        </div>
        <div class="col-md-4">
          <label class="form-label fw-semibold small mb-2">State</label>
          <vue-select :options="shipping_states" label="name" v-model="shipping_state" />
          <small class="text-danger" v-if="errors.shipping_state">{{ errors.shipping_state[0] }}</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer border-top px-4 py-3">
    <button type="button" class="btn btn-outline-secondary btn-sm px-4 me-2" data-bs-dismiss="modal">Cancel</button>
    <button type="submit" class="btn btn-primary btn-sm px-4">Save</button>
  </div>
</form>
  </div>
</div>
</div>

<!-- Assign Modal (Compact) -->
<div class="modal fade" id="customer_assign_modal" tabindex="-1">
<div class="modal-dialog modal-dialog-centered modal-sm">
  <div class="modal-content">
    <div class="modal-header bg-warning text-dark border-0">
      <h6 class="modal-title mb-0"><i class="ti ti-user-check me-2"></i>Assign Customer</h6>
      <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
    </div>
    <form @submit.prevent="assignCustomer">
      <div class="modal-body p-3">
        <div class="mb-3">
          <label class="form-label fw-semibold small">Assign To</label>
          <select class="form-select" v-model="user_id">
            <option v-for="row in users" :key="row.id" :value="row.id">{{ row.name }}</option>
          </select>
          <small v-if="errors.user_id" class="text-danger">{{ errors.user_id[0] }}</small>
        </div>
        <div class="mb-0">
          <label class="form-label fw-semibold small">Remark</label>
          <textarea class="form-control" rows="2" v-model="remark"></textarea>
          <small v-if="errors.remark" class="text-danger">{{ errors.remark[0] }}</small>
        </div>
      </div>
      <div class="modal-footer border-top p-3">
        <button type="button" class="btn btn-outline-secondary btn-sm" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" class="btn btn-warning btn-sm">Assign</button>
      </div>
    </form>
  </div>
</div>
</div>

<!-- Delete Modal (Compact) -->
<div class="modal fade" id="customer_delete_modal" tabindex="-1">
<div class="modal-dialog modal-dialog-centered modal-sm">
<div class="modal-content">
<div class="modal-body p-4 text-center">
  <div class="mb-3">
    <i class="ti ti-trash-x text-danger fs-1"></i>
  </div>
  <h6 class="fw-bold text-danger mb-2">Confirm Delete?</h6>
  <p class="text-muted small mb-4">This action cannot be undone.</p>
  <div class="d-flex gap-2 justify-content-center">
    <button class="btn btn-outline-secondary btn-sm px-3" data-bs-dismiss="modal">Cancel</button>
    <button class="btn btn-danger btn-sm px-3" @click="deleteCustomer">Delete</button>
  </div>
</div>
</div>
</div>
</div>
</template>

<style scoped>
.nav-tabs-compact .nav-link{
 padding: 0.5rem 1rem;
 font-size: 0.875rem;
 border: none;
 border-bottom: 2px solid transparent;
}

.nav-tabs-compact .nav-link.active{
 border-bottom-color: #0d6efd;
 background: transparent;
}

.form-label{
 font-size: 0.8125rem;
}
.shadow-lg{
 box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
}
</style>

